import { PaywallContent } from '~/src/components/paywall'

const PaywallStep: React.FC = () => {
  return <PaywallContent source='onboarding' />
}

export default PaywallStep
